export default __webpack_public_path__ + "fb902f24455fdfd966d9cf27da2b49f0.png";